<template>
  <div :class="componentClassName">
    <section class="t-entry__col t-entry__col--login">
      <div class="t-entry__login-block">
        <div v-if="$props.class.indexOf('t-login') !== 0" class="t-entry__login-composite-logo">
          <a id="composite" :href="compositeUrl" target="_blank">
            <img src="@/images/composite_yoko_rgb_color.svg" />
          </a>
        </div>
        <div class="t-entry__login-logo">
          <img
            v-if="$props.class.indexOf('t-login') === 0"
            src="@/images/cotoha-call-center-logo-square.svg"
            height="100"
          />
          <div v-if="$props.class.indexOf('t-login') !== 0" class="t-entry__logo-cotoha">
            <img src="@/images/cotoha-call-center-logo-horizontal.svg" alt="COTOHA Call Center" height="95" />
          </div>
        </div>
        <div class="t-entry__login-graphic">
          <img src="@/images/pages/login-graphic.svg" />
        </div>
      </div>
    </section>

    <section class="t-entry__col">
      <div class="t-entry__form-wrapper">
        <a-heading class="t-entry__heading" tag="h1" variant="center" :heading="heading" :subheading="subHeading" />
        <div class="t-entry__form-wrapper-text">
          <p align="center">
            COTOHA Call Centerのご提供は、<br />
            2025年3月31日をもちまして終了します。<br />
            サービス終了に関するおしらせは
            <a :href="serviceEndUrl" target="blank">こちら</a>
          </p>
        </div>
        <a-section-divider />

        <div class="t-entry__body">
          <slot></slot>
        </div>
      </div>

      <o-global-footer class="t-entry__footer">
        <m-link-container>
          <li>
            <a id="help" class="a-button a-button--text a-button--small a-button--link" :href="helpUrl">ヘルプ</a>
          </li>
          <li>
            <a
              id="privacyPolicy"
              class="a-button a-button--text a-button--small a-button--link"
              :href="privacyPolicyUrl"
              >プライバシーポリシー</a
            >
          </li>
          <li>
            <a
              id="termsOfService"
              class="a-button a-button--text a-button--small a-button--link"
              :href="termsUrl"
              target="_blank"
              title="別ウインドウにてPDF文書が表示されます。"
              >利用規約(1038KB)</a
            ><img src="/public/PDF_32.png" class="t-entry__icon-margin" width="32" height="32" />
          </li>
        </m-link-container>
      </o-global-footer>
    </section>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import { CCC_SERVICE_END_URL } from '@/libs/constants';

import AButton from '@/components/atoms/button';
import AHeading from '@/components/atoms/heading';
import ASectionDivider from '@/components/atoms/section-divider';
import MLinkContainer from '@/components/molecules/link-container';
import OGlobalFooter from '@/components/organisms/global-footer';

export default {
  name: 't-default-entry',
  components: {
    //AButton,
    AHeading,
    ASectionDivider,
    MLinkContainer,
    OGlobalFooter,
  },
  props: {
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    class: {
      type: String,
      default: '',
    },
    heading: {
      type: String,
      default: null,
    },
    subHeading: {
      type: String,
      default: null,
    },
    navigationItems: {
      type: Array,
      default: new Array(0),
    },
    activeNavId: {
      type: String,
      default: '',
    },
    helpUrl: {
      type: String,
      default: 'https://support.ntt.com/ccaas/inquiry/search',
    },
    privacyPolicyUrl: {
      type: String,
      default: 'https://www.ntt.com/about-us/hp/privacy.html',
    },
    termsUrl: {
      type: String,
      default: 'https://www.ntt.com/content/dam/nttcom/hq/jp/about-us/disclosure/tariff/pdf/c325.pdf',
    },
    termsSize: {
      type: String,
      default: '1038KB',
    },
    compositeUrl: {
      type: String,
      default: 'https://www.ntt.com',
    },
    serviceEndUrl: {
      type: String,
      default: CCC_SERVICE_END_URL,
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-entry');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
};
</script>
